import React from "react";

function getColor(count) {
  if (count === 0) return "bg-white/[0.04]";
  if (count === 1) return "bg-indigo-900";
  if (count <= 3) return "bg-indigo-600";
  if (count <= 6) return "bg-indigo-400";
  return "bg-indigo-300";
}

export default function ActivityHeatmap({ data }) {
  const countByDate = Object.fromEntries((data || []).map((d) => [d.date, d.count]));
  const today = new Date();
  const days = [];
  for (let i = 364; i >= 0; i--) {
    const d = new Date(today);
    d.setDate(d.getDate() - i);
    const iso = d.toISOString().slice(0, 10);
    days.push({ date: iso, count: countByDate[iso] || 0 });
  }
  const weeks = [];
  for (let i = 0; i < days.length; i += 7) weeks.push(days.slice(i, i + 7));
  const totalActive = (data || []).reduce((sum, d) => sum + d.count, 0);

  return (
    <div data-testid="portfolio-activity-heatmap">
      <p className="text-xs text-slate-400 mb-3">{totalActive} learning activities in the last year</p>
      <div className="flex gap-[3px] overflow-x-auto pb-2">
        {weeks.map((week, wi) => (
          <div key={wi} className="flex flex-col gap-[3px]">
            {week.map((d) => (
              <div key={d.date} title={`${d.date}: ${d.count} activities`} className={`w-[10px] h-[10px] rounded-sm ${getColor(d.count)}`} data-testid={`heatmap-cell-${d.date}`} />
            ))}
          </div>
        ))}
      </div>
      <div className="flex items-center gap-1.5 mt-2 justify-end">
        <span className="text-[10px] text-slate-400">Less</span>
        {[0, 1, 2, 4, 7].map((c) => <div key={c} className={`w-[10px] h-[10px] rounded-sm ${getColor(c)}`} />)}
        <span className="text-[10px] text-slate-400">More</span>
      </div>
    </div>
  );
}
